import React from 'react';
import EnhancedFractionsGame from './EnhancedFractionsGame';

function App() {
  return (
    <div className="App">
      <EnhancedFractionsGame />
    </div>
  );
}

export default App;